<template>
  <div class="bg-[#34281A]/10 p-6 w-72">
    <div class="">
      <div>
        <img 
          v-if="data.avatar"
          :src="data.avatar.xs"
          :alt="data.agentName"
          class="block mx-auto w-32 h-32 object-cover rounded-full" 
        />
        <div v-else class="w-32 h-32 bg-white rounded-full block mx-auto"></div>
      </div>
      <div class="mt-6 space-y-2 text-center">
        <div class="font-semibold text-lg">{{ data.agentName }}</div>
        <div class="">
          <div class="text-base font-medium" v-if="data.agentTitle">{{ data.agentTitle }}</div>
          <div class="text-base font-medium" v-if="data.brokerageName">{{ data.brokerageName }}</div>
        </div>
      </div>

      <div class="mt-8 space-y-8">
        <div class="text-sm font-medium text-center" v-if="data.address">
          {{ data.address }}, {{ data.city }}, {{ data.state }} {{ data.zipcode }}, {{ data.country }}
        </div>
        <a v-if="data.phone" :href="`tel:${data.phone}`" class="flex gap-2 text-sm font-medium justify-center hover:underline!">
          <FontAwesomeIcon icon="phone" class="relative top-0.5" /> {{ data.phone }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContactAgent',
    props: {
			data: {
				type: Object
			}
		}
  };
</script>

<style lang="scss">
  // @import '../../../../styles/mixins.scss';

  // // @include lgScreen()

  // .contact-agent {
  //   width: 100%;
  //   margin-bottom: 20px;
  //   padding: 25px;
  //   background-color: #F4F4F4;

  //   &__main {
  //     display: flex;
  //     margin-bottom: 40px;
  //   }

  //   &__avatar {
  //     width: 80px;
  //     min-width: 80px;
  //     max-width: 80px;
  //     height: 80px;
  //     margin-right: 20px;
  //     overflow: hidden;
  //     border-radius: 50%;
  //     background-color: #e9e9e9;
      
  //     &-img {
  //       max-width: 100%;
  //       object-fit: cover;
  //     }
  //   }

  //   &__description {
  //     display: flex;
  //     flex-wrap: wrap;
  //     align-items: center;

  //     & > * {
  //       width: 100%;
  //     }
  //   }

  //   &__name {
  //     margin-bottom: 10px;;
  //     font-size: 16px;
  //     font-weight: 600;
  //   }

  //   &__title {
  //     margin-bottom: 10px;
  //     font-size: 14px;
  //     font-weight: 300;
  //   }

  //   &__brokerage-name {
  //     font-size: 14px;
  //     font-weight: 300;
  //   }

  //   &__address {
  //     position: relative;
  //     margin-bottom: 35px;
  //     padding-left: 30px;
  //     font-size: 14px;
  //     font-weight: 300;

  //     svg {
  //       position: absolute;
  //       left: 0;
  //       top: -2px;
  //       font-size: 16px;
  //       color: #1a1c21;
  //     }
  //   }

  //   &__phone {
  //     font-size: 20px;
  //     font-weight: 600;

  //     svg {
  //       font-size: 16px;
  //       margin-right: 10px;
  //       color: #1a1c21;
  //     }

  //     &:hover {
  //       text-decoration: underline;
  //     }
  //   }
  // }
</style>
